/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemRefundFull,
  LineItemRefundFullOptional,
  LineItemRefundFullMetaI,
  LineItemRefundFullTrackedI,
} from "./line-item-refund-full";
import {
  LineItemRefundFullTracked,
  LineItemRefundFullMeta,
} from "./line-item-refund-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemRefundTaxDTO,
  LineItemRefundTaxDTOOptional,
  LineItemRefundTaxDTOMetaI,
  LineItemRefundTaxDTOTrackedI,
} from "./line-item-refund-tax-dto";
import {
  LineItemRefundTaxDTOTracked,
  LineItemRefundTaxDTOMeta,
} from "./line-item-refund-tax-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchaseStockedItemDTO,
  PurchaseStockedItemDTOOptional,
  PurchaseStockedItemDTOMetaI,
  PurchaseStockedItemDTOTrackedI,
} from "./purchase-stocked-item-dto";
import {
  PurchaseStockedItemDTOTracked,
  PurchaseStockedItemDTOMeta,
} from "./purchase-stocked-item-dto";

/**
 *
 * @export
 * @interface LineItemRefundDTO
 */
export interface LineItemRefundDTOOptional extends LineItemRefundFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  amountToRefundUnitCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  refundQuantity?: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  returnStock?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  revokeAfter?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  revokeDuring?: boolean;
  /**
   *
   * @type {PurchaseStockedItemDTO}
   * @memberof LineItemRefundDTO
   */
  restock?: PurchaseStockedItemDTOOptional;
  /**
   *
   * @type {Array<LineItemRefundTaxDTO>}
   * @memberof LineItemRefundDTO
   */
  includeTaxes?: LineItemRefundTaxDTOOptional[];
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  amountToRefundTotalCents?: number;
}

export interface LineItemRefundDTO
  extends LineItemRefundDTOOptional, LineItemRefundFull {
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  amountToRefundUnitCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  amountRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  refundQuantity?: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  returnStock?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  revokeAfter?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  revokeDuring?: boolean;
  /**
   *
   * @type {PurchaseStockedItemDTO}
   * @memberof LineItemRefundDTO
   */
  restock?: PurchaseStockedItemDTO;
  /**
   *
   * @type {Array<LineItemRefundTaxDTO>}
   * @memberof LineItemRefundDTO
   */
  includeTaxes?: LineItemRefundTaxDTO[];
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  amountToRefundTotalCents?: number;
}

export interface LineItemRefundDTOTrackedI extends LineItemRefundFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  amountToRefundUnitCents?: number;
  amountToRefundUnitCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  amountRefundedCents?: number;
  amountRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  refundQuantity?: number;
  refundQuantityIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  returnStock?: boolean;
  returnStockIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  revokeAfter?: boolean;
  revokeAfterIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemRefundDTO
   */
  revokeDuring?: boolean;
  revokeDuringIsSet: boolean;
  /**
   *
   * @type {PurchaseStockedItemDTO}
   * @memberof LineItemRefundDTO
   */
  restock?: PurchaseStockedItemDTOTrackedI;
  restockIsSet: boolean;
  /**
   *
   * @type {Array<LineItemRefundTaxDTO>}
   * @memberof LineItemRefundDTO
   */
  includeTaxes?: LineItemRefundTaxDTOTrackedI[];
  includeTaxesIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemRefundDTO
   */
  amountToRefundTotalCents?: number;
  amountToRefundTotalCentsIsSet: boolean;
}

transformDatesMap.set("LineItemRefundDTO", function (model: LineItemRefundDTO) {
  const transformDatesrestock = transformDatesMap.get("PurchaseStockedItemDTO");
  if (transformDatesrestock && model.restock) {
    transformDatesrestock(model.restock);
  }
  const transformDatesincludeTaxes = transformDatesMap.get(
    "LineItemRefundTaxDTO",
  );
  if (transformDatesincludeTaxes) {
    model.includeTaxes?.forEach((sub) => {
      transformDatesincludeTaxes(sub);
    });
  }
});

export type LineItemRefundDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountToRefundUnitCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  refundQuantity: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  returnStock: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  revokeAfter: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  revokeDuring: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  restock: PropertyMeta<PurchaseStockedItemDTOMetaI>;
  //isDate: false
  //isDatetime: false
  includeTaxes: PropertyMeta<LineItemRefundTaxDTOMetaI>;
  //isDate: false
  //isDatetime: false
  amountToRefundTotalCents: PropertyMeta<MetaTypeBase<number>>;
}>;

export var LineItemRefundDTOMeta: LineItemRefundDTOMetaI =
  {} as LineItemRefundDTOMetaI;
LineItemRefundDTOMeta = typeMeta("LineItemRefundDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  amountToRefundUnitCents: propertyMeta(
    "amountToRefundUnitCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountRefundedCents: propertyMeta(
    "amountRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  refundQuantity: propertyMeta(
    "refundQuantity",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  returnStock: propertyMeta(
    "returnStock",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  revokeAfter: propertyMeta(
    "revokeAfter",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  revokeDuring: propertyMeta(
    "revokeDuring",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  restock: propertyMeta(
    "restock",
    false,
    false,
    false,
    PurchaseStockedItemDTOMeta,
  ),
  includeTaxes: propertyMeta(
    "includeTaxes",
    true,
    false,
    false,
    LineItemRefundTaxDTOMeta,
  ),
  amountToRefundTotalCents: propertyMeta(
    "amountToRefundTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = LineItemRefundDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([LineItemRefundFullMeta]);
  metaI.isDeleted.inheritedFrom = LineItemRefundFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = LineItemRefundFullMeta.isNew;
  metaI.assignId.inheritedFrom = LineItemRefundFullMeta.assignId;
  metaI.amountToRefundUnitCents.inheritedFrom =
    LineItemRefundFullMeta.amountToRefundUnitCents;
  metaI.amountRefundedCents.inheritedFrom =
    LineItemRefundFullMeta.amountRefundedCents;
  metaI.refundQuantity.inheritedFrom = LineItemRefundFullMeta.refundQuantity;
  metaI.returnStock.inheritedFrom = LineItemRefundFullMeta.returnStock;
  metaI.revokeAfter.inheritedFrom = LineItemRefundFullMeta.revokeAfter;
  metaI.revokeDuring.inheritedFrom = LineItemRefundFullMeta.revokeDuring;
});

export class LineItemRefundDTOTracked
  extends LineItemRefundFullTracked
  implements LineItemRefundDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  amountToRefundUnitCents__I?: number = undefined;
  amountToRefundUnitCentsIsSet: boolean = false;
  set amountToRefundUnitCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToRefundUnitCents__I = v;
      this.amountToRefundUnitCentsIsSet = true;
    } else {
      this.amountToRefundUnitCents__I = v || undefined;
      this.amountToRefundUnitCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToRefundUnitCents() {
    return this.amountToRefundUnitCents__I;
  }
  amountRefundedCents__I?: number = undefined;
  amountRefundedCentsIsSet: boolean = false;
  set amountRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountRefundedCents__I = v;
      this.amountRefundedCentsIsSet = true;
    } else {
      this.amountRefundedCents__I = v || undefined;
      this.amountRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountRefundedCents() {
    return this.amountRefundedCents__I;
  }
  refundQuantity__I?: number = undefined;
  refundQuantityIsSet: boolean = false;
  set refundQuantity(v: undefined | number) {
    if (v !== undefined) {
      this.refundQuantity__I = v;
      this.refundQuantityIsSet = true;
    } else {
      this.refundQuantity__I = v || undefined;
      this.refundQuantityIsSet = false;
    }
    this.changeTracker = true;
  }
  get refundQuantity() {
    return this.refundQuantity__I;
  }
  returnStock__I?: boolean = undefined;
  returnStockIsSet: boolean = false;
  set returnStock(v: undefined | boolean) {
    if (v !== undefined) {
      this.returnStock__I = v;
      this.returnStockIsSet = true;
    } else {
      this.returnStock__I = v || undefined;
      this.returnStockIsSet = false;
    }
    this.changeTracker = true;
  }
  get returnStock() {
    return this.returnStock__I;
  }
  revokeAfter__I?: boolean = undefined;
  revokeAfterIsSet: boolean = false;
  set revokeAfter(v: undefined | boolean) {
    if (v !== undefined) {
      this.revokeAfter__I = v;
      this.revokeAfterIsSet = true;
    } else {
      this.revokeAfter__I = v || undefined;
      this.revokeAfterIsSet = false;
    }
    this.changeTracker = true;
  }
  get revokeAfter() {
    return this.revokeAfter__I;
  }
  revokeDuring__I?: boolean = undefined;
  revokeDuringIsSet: boolean = false;
  set revokeDuring(v: undefined | boolean) {
    if (v !== undefined) {
      this.revokeDuring__I = v;
      this.revokeDuringIsSet = true;
    } else {
      this.revokeDuring__I = v || undefined;
      this.revokeDuringIsSet = false;
    }
    this.changeTracker = true;
  }
  get revokeDuring() {
    return this.revokeDuring__I;
  }
  restock__I?: PurchaseStockedItemDTOTracked = undefined;
  restockIsSet: boolean = false;
  set restock(v: undefined | PurchaseStockedItemDTOTracked) {
    if (v !== undefined) {
      this.restock__I = v;
      this.restockIsSet = true;
    } else {
      this.restock__I = v || undefined;
      this.restockIsSet = false;
    }
    this.changeTracker = true;
  }
  get restock() {
    return this.restock__I;
  }
  includeTaxes__I?: LineItemRefundTaxDTOTracked[] = undefined;
  includeTaxesIsSet: boolean = false;
  set includeTaxes(v: undefined | LineItemRefundTaxDTOTracked[]) {
    if (v !== undefined) {
      this.includeTaxes__I = v;
      this.includeTaxesIsSet = true;
    } else {
      this.includeTaxes__I = v || undefined;
      this.includeTaxesIsSet = false;
    }
    this.changeTracker = true;
  }
  get includeTaxes() {
    return this.includeTaxes__I;
  }
  amountToRefundTotalCents__I?: number = undefined;
  amountToRefundTotalCentsIsSet: boolean = false;
  set amountToRefundTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountToRefundTotalCents__I = v;
      this.amountToRefundTotalCentsIsSet = true;
    } else {
      this.amountToRefundTotalCents__I = v || undefined;
      this.amountToRefundTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountToRefundTotalCents() {
    return this.amountToRefundTotalCents__I;
  }
  constructor(config?: LineItemRefundDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.restock?.setIds();

    this.includeTaxes?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: LineItemRefundDTOOptional,
    options?: AssignOptions,
  ): LineItemRefundDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.amountToRefundUnitCents &&
      this.amountToRefundUnitCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToRefundUnitCents = config.amountToRefundUnitCents;
      if (optionsRequired.unassign) this.amountToRefundUnitCentsIsSet = false;
      else this.amountToRefundUnitCentsIsSet = true;
    }
    if (
      config.amountRefundedCents &&
      this.amountRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountRefundedCents = config.amountRefundedCents;
      if (optionsRequired.unassign) this.amountRefundedCentsIsSet = false;
      else this.amountRefundedCentsIsSet = true;
    }
    if (
      config.refundQuantity &&
      this.refundQuantityApplyFilter(optionsRequired.filter)
    ) {
      this.refundQuantity = config.refundQuantity;
      if (optionsRequired.unassign) this.refundQuantityIsSet = false;
      else this.refundQuantityIsSet = true;
    }
    if (
      config.returnStock &&
      this.returnStockApplyFilter(optionsRequired.filter)
    ) {
      this.returnStock = config.returnStock;
      if (optionsRequired.unassign) this.returnStockIsSet = false;
      else this.returnStockIsSet = true;
    }
    if (
      config.revokeAfter &&
      this.revokeAfterApplyFilter(optionsRequired.filter)
    ) {
      this.revokeAfter = config.revokeAfter;
      if (optionsRequired.unassign) this.revokeAfterIsSet = false;
      else this.revokeAfterIsSet = true;
    }
    if (
      config.revokeDuring &&
      this.revokeDuringApplyFilter(optionsRequired.filter)
    ) {
      this.revokeDuring = config.revokeDuring;
      if (optionsRequired.unassign) this.revokeDuringIsSet = false;
      else this.revokeDuringIsSet = true;
    }
    if (config.restock && this.restockApplyFilter(optionsRequired.filter)) {
      this.restock = new PurchaseStockedItemDTOTracked(config.restock, options);
      if (optionsRequired.unassign) this.restockIsSet = false;
      else this.restockIsSet = true;
    }
    if (
      config.includeTaxes &&
      this.includeTaxesApplyFilter(optionsRequired.filter)
    ) {
      this.includeTaxes = config.includeTaxes?.map(
        (a) => new LineItemRefundTaxDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.includeTaxesIsSet = false;
      else this.includeTaxesIsSet = true;
    }
    if (
      config.amountToRefundTotalCents &&
      this.amountToRefundTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountToRefundTotalCents = config.amountToRefundTotalCents;
      if (optionsRequired.unassign) this.amountToRefundTotalCentsIsSet = false;
      else this.amountToRefundTotalCentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemRefundDTOTrackedI {
    const cloned = {} as LineItemRefundDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.amountToRefundUnitCentsIsSetDeep() &&
      this.amountToRefundUnitCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToRefundUnitCentsIsSet = true;
      cloned.amountToRefundUnitCents = this.amountToRefundUnitCents;
    } else {
      //cloned.amountToRefundUnitCentsIsSet = false
    }
    if (
      this.amountRefundedCentsIsSetDeep() &&
      this.amountRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountRefundedCentsIsSet = true;
      cloned.amountRefundedCents = this.amountRefundedCents;
    } else {
      //cloned.amountRefundedCentsIsSet = false
    }
    if (
      this.refundQuantityIsSetDeep() &&
      this.refundQuantityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.refundQuantityIsSet = true;
      cloned.refundQuantity = this.refundQuantity;
    } else {
      //cloned.refundQuantityIsSet = false
    }
    if (
      this.returnStockIsSetDeep() &&
      this.returnStockApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.returnStockIsSet = true;
      cloned.returnStock = this.returnStock;
    } else {
      //cloned.returnStockIsSet = false
    }
    if (
      this.revokeAfterIsSetDeep() &&
      this.revokeAfterApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.revokeAfterIsSet = true;
      cloned.revokeAfter = this.revokeAfter;
    } else {
      //cloned.revokeAfterIsSet = false
    }
    if (
      this.revokeDuringIsSetDeep() &&
      this.revokeDuringApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.revokeDuringIsSet = true;
      cloned.revokeDuring = this.revokeDuring;
    } else {
      //cloned.revokeDuringIsSet = false
    }
    if (
      this.restockIsSetDeep() &&
      this.restockApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.restockIsSet = true;
      cloned.restock = this.restock?.removeUnset(filter);
    } else {
      //cloned.restockIsSet = false
    }
    if (
      this.includeTaxesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.includeTaxesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.includeTaxesIsSet = true;
      cloned.includeTaxes = this.includeTaxes
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.includeTaxesIsSet = false
    }
    if (
      this.amountToRefundTotalCentsIsSetDeep() &&
      this.amountToRefundTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountToRefundTotalCentsIsSet = true;
      cloned.amountToRefundTotalCents = this.amountToRefundTotalCents;
    } else {
      //cloned.amountToRefundTotalCentsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemRefundDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.amountToRefundUnitCentsApplyFilter(filter))
      this.amountToRefundUnitCentsIsSet = false;

    if (!this.amountRefundedCentsApplyFilter(filter))
      this.amountRefundedCentsIsSet = false;

    if (!this.refundQuantityApplyFilter(filter))
      this.refundQuantityIsSet = false;

    if (!this.returnStockApplyFilter(filter)) this.returnStockIsSet = false;

    if (!this.revokeAfterApplyFilter(filter)) this.revokeAfterIsSet = false;

    if (!this.revokeDuringApplyFilter(filter)) this.revokeDuringIsSet = false;

    if (!this.restockApplyFilter(filter)) this.restockIsSet = false;
    this.restock?.unassignAll(filter);

    if (!this.includeTaxesApplyFilter(filter)) this.includeTaxesIsSet = false;

    this.includeTaxes?.forEach((a) => a.unassignAll(filter));
    if (!this.amountToRefundTotalCentsApplyFilter(filter))
      this.amountToRefundTotalCentsIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.isDeleted,
      LineItemRefundDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.isNew,
      LineItemRefundDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.assignId,
      LineItemRefundDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  amountToRefundUnitCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.amountToRefundUnitCents,
      LineItemRefundDTOMeta,
      this.amountToRefundUnitCents,
      this,
    );
  }
  amountToRefundUnitCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountToRefundUnitCentsIsSet &&
      this.amountToRefundUnitCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.amountRefundedCents,
      LineItemRefundDTOMeta,
      this.amountRefundedCents,
      this,
    );
  }
  amountRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountRefundedCentsIsSet &&
      this.amountRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  refundQuantityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.refundQuantity,
      LineItemRefundDTOMeta,
      this.refundQuantity,
      this,
    );
  }
  refundQuantityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.refundQuantityIsSet && this.refundQuantityApplyFilter(filter))
      return true;

    return false;
  }
  returnStockApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.returnStock,
      LineItemRefundDTOMeta,
      this.returnStock,
      this,
    );
  }
  returnStockIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.returnStockIsSet && this.returnStockApplyFilter(filter))
      return true;

    return false;
  }
  revokeAfterApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.revokeAfter,
      LineItemRefundDTOMeta,
      this.revokeAfter,
      this,
    );
  }
  revokeAfterIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.revokeAfterIsSet && this.revokeAfterApplyFilter(filter))
      return true;

    return false;
  }
  revokeDuringApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.revokeDuring,
      LineItemRefundDTOMeta,
      this.revokeDuring,
      this,
    );
  }
  revokeDuringIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.revokeDuringIsSet && this.revokeDuringApplyFilter(filter))
      return true;

    return false;
  }
  restockApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.restock,
      LineItemRefundDTOMeta,
      this.restock,
      this,
    );
  }
  restockIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.restockIsSet && this.restockApplyFilter(filter)) return true;
    return this.restock?.anySet(filter) == true;

    return false;
  }
  includeTaxesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.includeTaxes,
      LineItemRefundDTOMeta,
      this.includeTaxes,
      this,
    );
  }
  includeTaxesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.includeTaxesIsSet && this.includeTaxesApplyFilter(filter))
      return true;

    return this.includeTaxes?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  amountToRefundTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemRefundDTOMeta.amountToRefundTotalCents,
      LineItemRefundDTOMeta,
      this.amountToRefundTotalCents,
      this,
    );
  }
  amountToRefundTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountToRefundTotalCentsIsSet &&
      this.amountToRefundTotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.amountToRefundUnitCentsIsSetDeep(filter)) return true;
    if (this.amountRefundedCentsIsSetDeep(filter)) return true;
    if (this.refundQuantityIsSetDeep(filter)) return true;
    if (this.returnStockIsSetDeep(filter)) return true;
    if (this.revokeAfterIsSetDeep(filter)) return true;
    if (this.revokeDuringIsSetDeep(filter)) return true;
    if (this.restockIsSetDeep(filter)) return true;
    if (this.includeTaxesIsSetDeep(filter)) return true;
    if (this.amountToRefundTotalCentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
